import { render, staticRenderFns } from "./Assistance.vue?vue&type=template&id=79f0d918&scoped=true"
import script from "./Assistance.vue?vue&type=script&lang=js"
export * from "./Assistance.vue?vue&type=script&lang=js"
import style0 from "./Assistance.vue?vue&type=style&index=0&id=79f0d918&prod&lang=css"
import style1 from "./Assistance.vue?vue&type=style&index=1&id=79f0d918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f0d918",
  null
  
)

export default component.exports